module.exports = __webpack_public_path__ + "img/skredfaresone.f247c7d7.jpg";